import { Card, Row, Col, Typography, Button, message, Modal, Form, Input, Select, List, Space } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { getClassificacoes } from "../../api/classificacoes";
import { addFormacao, deleteFormacao, getFormacoes } from "../../api/formacoes";
import { configModal } from "../modalConfig/config";
const { Text } = Typography;

const validator = {
  descricao: [{ required: true, message: "Informe o curso!" }],
  id_cad_classificacao_escolaridade: [{ required: true, message: "Selecione a classificação!" }],
  situacao: [{ required: true, message: "Selecione a situação!" }],
};

const HomeFormacao = () => {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [classificacoes, setClassificacoes] = useState([]);
  const [form] = Form.useForm();
  const [modal, contextHolder] = Modal.useModal();
  const id_cad_classificacao_escolaridade = Form.useWatch("id_cad_classificacao_escolaridade", form);

  useEffect(() => {
    listar();
    listarClassificacoes();
  }, []);

  const listarClassificacoes = async () => {
    setLoading(true);
    try {
      const retorno = await getClassificacoes();
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_classificacoes = [];
        for (let index = 0; index < data?.length; index++) {
          array_classificacoes.push({
            value: data?.[index]?.id,
            label: data?.[index]?.descricao,
            complemento: data?.[index]?.complemento,
          });
        }
        setClassificacoes(array_classificacoes);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const listar = async () => {
    setLoading(true);
    try {
      const retorno = await getFormacoes();
      if (retorno?.statusCode === 200) {
        setDados(retorno?.response?.data);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const adicionarFormacao = async (formulario) => {
    setLoading(true);
    try {
      const retorno = await addFormacao(formulario);
      if (retorno?.statusCode === 200) {
        message.success("Registro inserido com sucesso!");
        setShowModal(false);
        form?.resetFields();
        listar();
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const deletar = async (id) => {
    setLoading(true);
    try {
      const retorno = await deleteFormacao(id);
      if (retorno?.statusCode === 200) {
        message.success("Registro excluído com sucesso!");
        listar();
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    adicionarFormacao(formulario);
  };

  const renderClassificacoesComplementos = (classificacoes_array) => {
    const obj = {};

    classificacoes_array?.forEach((element) => {
      obj[element?.value] = element?.complemento === 1 ? true : false;
    });

    return obj;
  };

  const classificacoesComplemento = classificacoes?.length > 0 ? renderClassificacoesComplementos(classificacoes) : {};

  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text className="title-middle">
            <EditOutlined /> Adicionar Formação
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={800}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          form?.resetFields();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                name="id_cad_classificacao_escolaridade"
                label="Classificação"
                hasFeedback
                rules={validator?.id_cad_classificacao_escolaridade}>
                <Select
                  size="large"
                  listHeight={350}
                  placeholder="Selecione a classificação"
                  options={classificacoes}
                  disabled={loading}
                />
              </Form.Item>
            </Col>

            {classificacoesComplemento[id_cad_classificacao_escolaridade] && (
              <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item name="descricao" label="Curso" hasFeedback rules={validator?.descricao}>
                  <Input size="large" placeholder="Informe o curso" disabled={loading} />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Card
      title={
        <div className="card-header-content">
          <Text className="title-middle">Formações</Text>
          <Button
            icon={<PlusOutlined />}
            onClick={() => {
              form?.resetFields();
              setShowModal(true);
            }}
            type="link">
            Adicionar
          </Button>
        </div>
      }
      className="shadow">
      {modalFormulario()}

      <List
        loading={loading}
        dataSource={dados}
        renderItem={(item) => (
          <List.Item>
            <Space className="card-header-content full-width" wrap>
              <Space direction="vertical" size={0}>
                <Text strong>{item?.classificacao}</Text>
                <Text type="secondary">{item?.descricao ? item?.descricao : item?.classificacao}</Text>
              </Space>

              <Space size={0}>
                <Button
                  size="large"
                  danger
                  type="text"
                  loading={loading}
                  icon={<DeleteOutlined />}
                  onClick={() =>
                    modal.confirm({
                      ...configModal,
                      title: "Atenção",
                      content: "Deseja deletar este registro?",
                      onOk() {
                        deletar(item?.id);
                      },
                    })
                  }
                />
              </Space>
            </Space>
          </List.Item>
        )}
      />

      {contextHolder}
    </Card>
  );
};

export { HomeFormacao };
